import { Controller } from '../utils/controller';

export default class extends Controller {
  static values = {
    link: String,
    isAbsolute: Number,
    isFragment: Number
  };

  // VALUES
  declare linkValue: string;
  declare isAbsoluteValue: number;
  declare isFragmentValue: number;

  // LOCAL STATE
  private isAbsolute: number;
  private isFragment: number;

  initialize() {
    this.isAbsolute = 1;
    this.isFragment = 1;
  }

  redirect() {
    const bannerContainer: string = (this.element.querySelector('p') as HTMLElement)?.innerText;

    const containerBannerEvent = new CustomEvent('analytics.containerPromo', {
      detail: {
        banner_promo_title: bannerContainer,
        banner_promo_url: this.linkValue
      }
    });
    window.dispatchEvent(containerBannerEvent);

    if (this.isAbsoluteValue === this.isAbsolute) {
      window.open(this.linkValue, '_blank', 'noreferrer');
      return;
    }

    if (this.isFragmentValue === this.isFragment) {
      window.scrollTo(0, document.getElementById(this.linkValue)?.offsetTop || 0);
      return;
    }

    window.location.href = this.linkValue;
  }

  connect() {
    this._jumpOverToFragmentIfHashExists();
  }

  _jumpOverToFragmentIfHashExists() {
    const isValidHashforId = (val: string) =>
      !!val && typeof val === 'string' && /^#[A-Za-z][-A-Za-z0-9._:]*$/.test(val);
    const { hash } = window.location;

    if (!isValidHashforId(hash)) {
      return;
    }

    const targetAnchor = this.element.querySelector(`a${hash}`);
    const offsetTop = targetAnchor != null && (targetAnchor as HTMLElement).offsetTop;

    if (offsetTop) {
      window.scrollTo({ top: offsetTop });
    }
  }

  handleKeyUp(event) {
    if (event.key === 'Enter') {
      this.redirect();
    }
  }
}
